export default {
  "end/aborted": {
    en: "Game has been aborted",
    fr: "La partie a été annulée",
  },
  "end/mate": {
    en: "Mate",
    fr: "Échec et mat",
  },
  "end/resign": {
    en: "Resigned",
    fr: "Abandon",
  },
  "end/stalemate": {
    en: "Stalemate",
    fr: "Pat",
  },
  "end/timeout": {
    en: "Flagged",
    fr: "Perdue au temps",
  },
  "end/outoftime": {
    en: "Flagged",
    fr: "Perdue au temps",
  },
  "end/draw": {
    en: "Draw",
    fr: "Partie nulle",
  },
  "end/cheat": {
    en: "Cheat!",
    fr: "Triche",
  },
  "end/noStart": {
    en: "Game didn't dtart",
    fr: "La partie n'a pas commencé",
  },
};
